import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
// import { immer } from "zustand/middleware/immer";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import devDebug from "../Helpers/debug";
import all_cpv_trees from "../Assets/CPVs/all_cpv_trees.json";
import { useTenderStrategyStore } from "./tenderStrategyStore";
import i18n from "../i18n";
import idbKeyvalAdapter from "./1_utility";

// define the initial state
const initialState = {
  reloadCPVs: false,
  cpvTrees: {
    tender_strategy: { default: all_cpv_trees[i18n.language.slice(0, 2)] },
    edit_user: { default: all_cpv_trees[i18n.language.slice(0, 2)] },
  },
  refreshCPVTree: {
    tender_strategy: { default: true },
    edit_user: { default: true },
  },
  CPVStage: "initial",
  templates: [],
  templatesLoaded: false,
  TPLName: "",
  multiSelectionMode: false,
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useCPVStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      // ----------------------- CPV SEARCH    -----------------------
      setMultiSelectionMode: (multiSelectionMode) =>
        set((state) => {
          state.multiSelectionMode = multiSelectionMode;
        }),
      // ----------------------- CPV TEMPLATES -----------------------
      // setSomething: (payload) =>
      //   set((state) => {
      //     state.reloadCPVs = payload;
      //   }),

      setTemplates: (templates) =>
        set((state) => {
          state.templates = templates;
        }),
      setTemplatesLoaded: (templatesLoaded) =>
        set((state) => {
          state.templatesLoaded = templatesLoaded;
        }),
      setTPLName: (TPLName) =>
        set((state) => {
          state.TPLName = TPLName;
        }),

      // ----------------------- CPV TREES AND OTHER -----------------------
      // setReloadCPVS: (payload) =>
      //   set((state) => {
      //     state.reloadCPVs = payload;
      //   }),
      setTree: (newCPVTree, section, id) =>
        set((state) => {
          state.cpvTrees[section][id] = newCPVTree;
        }),
      verifyCPVDataExists: () =>
        set((state) => {
          const allStrategies = {
            ...useTenderStrategyStore.getState().editableStrategies.tender_strategy,
            ...useTenderStrategyStore.getState().editableStrategies.edit_user,
          };

          let keys = {};

          for (let section of Object.keys(state.cpvTrees)) {
            for (let id of Object.keys(allStrategies)) {
              if (!Object.keys(state.cpvTrees[section]).includes(id)) {
                state.cpvTrees[section][id] = all_cpv_trees[i18n.language.slice(0, 2)];
                state.refreshCPVTree[section][id] = true;
              }
            }
          }
          for (let section of Object.keys(state.cpvTrees)) {
            for (let id of Object.keys(state.cpvTrees[section])) {
              if (!Object.keys(allStrategies).includes(id)) {
                if (!keys[section]) {
                  keys[section] = {};
                }
                if (id !== "default" && id !== "all" && id !== "anonymous") keys[section][id] = true;
              }
            }
          }
          for (let section of Object.keys(keys)) {
            for (let key of Object.keys(keys[section])) {
              delete state.cpvTrees[section][key];
              delete state.refreshCPVTree[section][key];
            }
          }
          // devDebug(
          //   `verifyCPVDataExists -> These keys don't exist anymore and should be deleted from mapData and mapState: ${JSON.stringify(
          //     keys
          //   )}`
          // );
        }),
      // setTree: (payload, section, id) =>
      //   set((state) => {
      //     state.cpvTrees[section][id] = payload;
      //   }),

      addDefaultCPVData: (section, id) =>
        set((state) => {
          state.cpvTrees[section][id] = all_cpv_trees[i18n.language.slice(0, 2)];
          state.refreshCPVTree[section][id] = true;
        }),
      transferCPVData: (section, oldID, NewID) =>
        set((state) => {
          state.cpvTrees[section][NewID] = {
            ...state.cpvTrees[section][oldID],
          };
          state.refreshCPVTree[section][NewID] = true;
          delete state.cpvTrees[section][oldID];
          delete state.refreshCPVTree[section][oldID];
        }),

      setRefreshCPVTree: (section, id, payload) =>
        set((state) => {
          state.refreshCPVTree[section][id] = payload;
        }),

      setCPVStage: (payload) =>
        set((state) => {
          state.CPVStage = payload;
        }),
      // ------------------- OTHER -----------------------
      setTutorialEnabled: (payload) => set(() => ({ tutorialEnabled: payload })),
      resetState: () => {
        useCPVStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => !["CPVStage", "refreshCPVTree"].includes(key))
        ),
      name: "cpvStore",
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[cpvStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[cpvStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[cpvStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[cpvStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[cpvStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[cpvStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[cpvStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[cpvStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[cpvStore] Error during rehydration. Store name: "cpvStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[cpvStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
